import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  IEnrollmentPolicyResponse,
  IEnrollmentPolicyResponseById,
  IEnrollmentPolicyQueryParams,
} from '../../interface/enrollmentPolicy.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { enrollmentPolicyService } from '../../services/enrollmentPolicy';

// Fetch all enrollment policies with optional query params
export const fetchEnrollmentPolicies = createAsyncThunk<
  IEnrollmentPolicyResponse,
  IEnrollmentPolicyQueryParams | undefined,
  { rejectValue: IErrorResponse }
>('enrollmentPolicy/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await enrollmentPolicyService.fetchEnrollmentPolicies(params);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

// Fetch single enrollment policy by ID
export const fetchEnrollmentPolicy = createAsyncThunk<
  IEnrollmentPolicyResponseById,
  string,
  { rejectValue: IErrorResponse }
>('enrollmentPolicy/fetch-one', async (policyId, { rejectWithValue }) => {
  try {
    const response = await enrollmentPolicyService.fetchEnrollmentPolicy(policyId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const enrollmentPolicyActions = {
  fetchEnrollmentPolicies,
  fetchEnrollmentPolicy,
};
